import React from 'react';
import BeaconChartWithLegend from 'src/components/BeaconV2Components/BeaconChartWithLegend/BeaconChartWithLegend';
import TopEntityChartV2 from 'src/components/BeaconV2Components/TopEntityChartV2/TopEntityChartV2';
import { saveBarChartAsDelimitedData } from 'src/utils/chartUtils';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { useAppSelector, useMainTimePeriodShortDisplayName, useComparisonTimePeriodShortDisplayName } from 'src/utils/Hooks';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import { BeaconSubtitleContainer } from 'src/components/BeaconV2Components/BeaconChartWithLegend/BeaconSubtitleContainer';
import { useEntityPhrasing, useTaxonomySubtitleText } from 'src/components/BeaconV2Components/common/BeaconProDynamicSubtitle/hooks';
import SubtitleFilters from 'src/components/Charts/SubtitleFilters';
import SplineChartLoading from 'src/components/BeaconV2Components/SplineChartLoading/SplineChartLoading';
import { useTrafficDataWithDPV } from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/utils/useTrafficDataWithDPV';

/**
 * Traffic by keyword with DPV
 */
const TrafficByKeywordWithDPV = () => {
  const legendLabel = useAppSelector((state) => state.mainTimePeriod.displayName);
  const legendComparisonLabel = useAppSelector((state) => state.comparisonTimePeriod.displayName);

  const entityPhrase = useEntityPhrasing();
  const taxonomyText = useTaxonomySubtitleText();
  const mainTimePeriodShortDisplayName = useMainTimePeriodShortDisplayName();
  const comparisonTimePeriodShortDisplayName = useComparisonTimePeriodShortDisplayName();

  const { currentData, comparisonData, categoryData, isDpvLoading, isTargetLoading } = useTrafficDataWithDPV();

  return (
    <BeaconChartWithLegend
      convertSeriesToDelimitedData={async () => {
        const label = 'Total Traffic by Keyword';

        return saveBarChartAsDelimitedData(currentData, comparisonData, {
          fileTitle: `Traffic - ${label}`,
          metricLabel: label
        });
      }}
      includeSummaryInfo={false}
      primaryLegendProps={{
        displayName: legendLabel
      }}
      comparisonLegendProps={{
        displayName: legendComparisonLabel
      }}
      loading={isDpvLoading || isTargetLoading}
      loadingComponent={<SplineChartLoading />}
      title="Total Traffic by Keyword"
      subtitle={
        <BeaconSubtitleContainer>
          <Text variant="body1">
            The chart displays the total traffic for {entityPhrase} {taxonomyText} in each keyword during the{' '}
            {mainTimePeriodShortDisplayName} period compared to the {comparisonTimePeriodShortDisplayName}.
            <SubtitleFilters />
          </Text>
        </BeaconSubtitleContainer>
      }
    >
      <TopEntityChartV2
        chartSeries={[
          {
            type: 'column',
            data: comparisonData,
            categories: categoryData,
            metricType: METRICTYPE.VOLUME
          },
          {
            type: 'column',
            data: currentData,
            categories: categoryData,
            metricType: METRICTYPE.VOLUME
          }
        ]}
      />
    </BeaconChartWithLegend>
  );
};

export default TrafficByKeywordWithDPV;
